export class ValidationResponse {

    /**
     * Was validation successful.
     */
    isSuccess: boolean = true;
    
    /**
     * Description of validation error.
     */
    error: string = "";

    /**
     * Creates new Successful ValidationResponse.
     * @returns New Successful ValidationResponse.
     */
    static Success(): ValidationResponse {
        return new ValidationResponse();
    }

    /**
     * Creates a new Error ValidationResponse.
     * @param errMessage Description of error to be displayed.
     * @returns New Error ValidationResponse.
     */
    static Error(errMessage: string): ValidationResponse {
        let resp: ValidationResponse = new ValidationResponse();
        resp.isSuccess = false;
        resp.error = errMessage;
        return resp;
    }
}